import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { Field, Form } from 'react-final-form';
import Select from 'react-select';
import { toast } from 'react-toastify';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    borderRadius: '12px',
    boxShadow: 24,
    p: 4,
};

export default function FormAdd(props) {
    const { validate, initialValues, handleBack, options, handleSubmit, openAddForm, setOpenAddForm, forChequeUpload } = props;
    const handleClose = () => setOpenAddForm(false);

    return (
        <Modal
            open={openAddForm}
            onClose={handleClose}
            aria-labelledby="add-provider-title"
            aria-describedby="add-provider-description"
        >
            <Box sx={style}>
                <Form
                    onSubmit={handleSubmit}
                    validate={validate}
                    initialValues={initialValues}
                    render={({ handleSubmit, valid }) => (
                        <form
                            onSubmit={(e) => {
                                if (!valid) toast.error('Please fill all required fields');
                                handleSubmit(e);
                            }}
                            className="space-y-6"
                        >
                            <div className="space-y-4">
                                <Field name="name">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Name
                                                {meta.touched && meta.error && <span className="text-red-500 ml-1">*</span>}
                                            </label>
                                            <input
                                                {...input}
                                                type="text"
                                                placeholder="Enter Name"
                                                className={`w-full px-4 py-2 rounded-md border focus:outline-none focus:ring-2 transition ${meta.touched && meta.error
                                                    ? 'border-red-500 focus:ring-red-300'
                                                    : 'border-gray-300 focus:ring-indigo-500'
                                                    }`}
                                            />
                                        </div>
                                    )}
                                </Field>
                                {forChequeUpload && (
                                    <Field name="cheque_path">
                                        {({ input, meta }) => (
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    Upload Cheque
                                                    {meta.touched && meta.error && (
                                                        <span className="text-red-500 text-base font-bold ml-1">*</span>
                                                    )}
                                                </label>
                                                <input
                                                    type="file"
                                                    accept=".pdf,.jpg,.png"
                                                    // ref={fileInputRef} // 👈 here
                                                    onChange={(e) => input.onChange(e.target.files[0])}
                                                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                />
                                                {meta.touched && meta.error && (
                                                    <span className="text-red-500 text-base font-bold ml-1">{meta.error}</span>
                                                )}
                                            </div>
                                        )}
                                    </Field>
                                )}
                                <Field name="status">
                                    {({ input, meta }) => (
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Status
                                                {meta.touched && meta.error && <span className="text-red-500 ml-1">*</span>}
                                            </label>
                                            <Select
                                                {...input}
                                                options={options}
                                                placeholder="Select Status"
                                                classNamePrefix="react-select"
                                                onChange={(option) => input.onChange(option?.value)}
                                                value={options.find((opt) => opt.value === input.value) || null}
                                            />
                                        </div>
                                    )}
                                </Field>
                            </div>
                            <div className="flex justify-end gap-3 pt-4">
                                <Button
                                    onClick={handleBack}
                                    variant="outlined"
                                    color="inherit"
                                    sx={{ textTransform: 'none' }}
                                >
                                    Back
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    sx={{ textTransform: 'none' }}
                                >
                                    Submit
                                </Button>
                            </div>
                        </form>
                    )}
                />
            </Box>
        </Modal>
    );
}
